<nav class="sidebar__menu" id="sidebar-menu">
  <ng-container *ngFor="let item of menu">
    <ng-container *ngIf="!item.hidden && (!item.adminGuard || isHost)">
      <a
        *ngIf="!item.externalUrl; else externalLink"
        [id]="item.ref"
        class="sidebar-menu-button"
        [ngClass]="{ 'sidebar-menu-button--active': isActive(item.ref || '') }"
        [data-qa]="'btn-' + item.icon"
        [attr.data-onboard-id]="'sidebar-btn-' + item.icon"
        [attr.href]="'/' + (item.router || '')"
        (click)="navigateTo(item.router); $event.preventDefault()"
      >
        <mat-icon class="sidebar-menu-button__icon" [svgIcon]="item.icon"></mat-icon>
        <span class="sidebar-menu-button__title">
          {{ item.label | translate }}
        </span>
      </a>
      <ng-template #externalLink>
        <a
          [id]="item.ref"
          class="sidebar-menu-button"
          [data-qa]="'btn-' + item.icon"
          [attr.data-onboard-id]="'sidebar-btn-' + item.icon"
          [href]="item.externalUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <mat-icon class="sidebar-menu-button__icon" [svgIcon]="item.icon"></mat-icon>
          <span class="sidebar-menu-button__title">
            {{ item.label | translate }}
          </span>
        </a>
      </ng-template>
    </ng-container>
  </ng-container>
</nav>
